export default "__VITE_ASSET__DvASsrdy__"